import { FieldLabel } from "../../components/productPackages/FieldInfoTip";

export default function MobileFormField({ label, help, error, children }) {
  return (
    <div className="mb-4">
      {label ? (
        <div className="mb-1 block text-sm font-medium text-laranjinha">
          <FieldLabel help={help}>{label}</FieldLabel>
        </div>
      ) : null}
      {children}
      {error ? <p className="mt-1 text-sm text-red-400">{error}</p> : null}
    </div>
  );
}
